import {
  formatManWon,
  FULL_DEDUCTION_LIMIT,
  GIFT_VALUE_RATE_PERCENT,
} from '@/constants/hometownDonationPolicy';

export interface MatchedInstitution {
  institutionId?: number;
  institutionSlugId?: string;
  institutionName?: string;
  matchType?: 'EXACT' | 'SAME_SIDO';
}

export const DONATION_BENEFIT_TEXT = `웰로에서 기부하면 ${formatManWon(FULL_DEDUCTION_LIMIT)}만원까지 전액 세액공제, ${formatManWon((FULL_DEDUCTION_LIMIT * GIFT_VALUE_RATE_PERCENT) / 100)}만원 상당 답례품도 받아요.`;

export const getHometownDonationNotice = (
  matchedInstitution?: MatchedInstitution | null,
) => {
  const { institutionId, institutionName, institutionSlugId, matchType } =
    matchedInstitution ?? {};

  if (!institutionId || !institutionName || !institutionSlugId || !matchType) {
    return {
      kind: 'GUIDE',
      text: '기부 방법과 세액공제 혜택을 확인해 보세요.',
    } as const;
  }

  return {
    kind: 'REGION',
    institutionId,
    institutionName,
    institutionSlugId,
    text:
      matchType === 'EXACT'
        ? DONATION_BENEFIT_TEXT
        : '이 글의 지역은 아직 기부를 받지 않아 같은 시·도 지자체를 소개해요.',
  } as const;
};
